module.exports = __webpack_public_path__ + "img/active-1.b667d2d2.png";